import React from "react";
import {
  FieldWrapper,
  FilterToggle,
  FilterSortGroup,
} from "./jobsFilterUtils";

export const PAYERS_SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "worker_type", label: "Worker Type" },
];

export function AccountingPayersFilterFields({
  focusedFieldId,
  onFocusClear,
  filterShowDeleted,
  setFilterShowDeleted,
  sortKey,
  setSortKey,
  sortDir,
  setSortDir,
}) {
  return (
    <>
      <FieldWrapper
        fieldId="showDeleted"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterToggle
          id="accounting-payers-show-deleted"
          label="Show Deleted"
          checked={!!filterShowDeleted}
          onChange={setFilterShowDeleted}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="sort"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSortGroup
          id="accounting-payers-sort"
          sortBy={sortKey}
          sortOrder={sortDir}
          onSortByChange={setSortKey}
          onSortOrderChange={setSortDir}
          sortOptions={PAYERS_SORT_OPTIONS}
        />
      </FieldWrapper>
    </>
  );
}

export function buildAccountingPayersFilterChips({
  searchTerm,
  filterShowDeleted,
}) {
  const chips = [];

  if (searchTerm) {
    chips.push({
      id: "search",
      key: "search",
      fieldId: "search",
      label: `Search: ${searchTerm}`,
    });
  }

  if (filterShowDeleted) {
    chips.push({
      id: "showDeleted",
      key: "showDeleted",
      fieldId: "showDeleted",
      label: "Show Deleted",
    });
  }

  return chips;
}
